// import { FileSpreadsheet, Plus, Printer, Search } from 'lucide-react'
// import React from 'react'
// import './VoucherReports.css'

// const VoucherReports = () => {
//   return (
//     <>
//       <div className="voucher-container">
//         <h1 className="voucher-heading">Voucher</h1>

//         {/* Overview Form Section */}
//         <section className="voucher-top">
//           <div className="voucher-top-redirect">
//             <h1>Voucher</h1>
//             <div className="voucher-redirect-btns">

//             <button><Plus size={15}/> Payment</button>
//             <button><Plus size={15}/> Receipt</button>
//             <button><Plus size={15}/> Contra</button>
//             <button><Plus size={15}/> Journal</button>
//             </div>
//           </div>
//           <form action="" className="voucher-form">
//             <div className="voucher-form-section">
//               <div className="voucher-form-input-fields">
//                 <label>Select Branch</label>
//                 <select name="" id="">
//                   <option value=""></option>
//                 </select>
//               </div>
//               <div className="voucher-form-input-fields">
//                 <label>Select Ledger</label>
//                 <select name="" id="">
//                   <option value=""></option>
//                 </select>
//               </div>
//               <div className="voucher-form-input-fields">
//                 <label>Select Voucher</label>
//                 <select name="" id="">
//                   <option value="">Selecet Voucher</option>
//                 </select>
//               </div>
              
//               <div className="voucher-form-input-fields">
//                 <label>Date</label>
//                 <input type="date" />
//               </div>
//               <div className="voucher-form-input-fields">
//                 <label>Start Date</label>
//                 <input type="date" />
//               </div>
//               <div className="voucher-form-input-fields">
//                 <label>End Date</label>
//                 <input type="date" />
//               </div>
//             </div>
//             <div className="voucher-form-submit-btn">
//               <button>Get Records</button>
//             </div>
//           </form>
//         </section>

//         {/* pdf download buttons */}
//         <div className="voucher-pdf-download-btns">
//           <button>
//             <FileSpreadsheet size={15} /> Download Excel
//           </button>
//           <button>
//             <FileSpreadsheet size={15}/> Download Financial Statement
//           </button>
//           <button>
//             <Printer size={15}/> Print
//           </button>
//         </div>

//         <div className="voucher-report-section">
//           <h2>Ledgers</h2>

//           <div className="voucher-report-table">
//             <table>
//               <thead>
//                 <tr>
//                   <th>SN.</th>
//                   <th>Date</th>
//                   <th>Voucher No</th>
//                   <th>Type</th>
//                   <th>Particular</th>
//                   <th className="amount-head">
//                     <div className="voucher-th-data">
//                       <h4>Amount</h4>
//                       <div className="voucher-th-amount">
//                         <span>DR</span>
//                         <span>CR</span>
//                         <span>Balance</span>
//                       </div>
//                     </div>
//                   </th>
//                   <th>View</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {/* Row Sample */}
//                 <tr>
//                   <td>1</td>
//                   <td>05/12/2025</td>
//                   <td>#L001</td>
//                   <td>VCR 12</td>
//                   <td>Description</td>
//                   <td className="amount-row">
//                     <span>200</span>
//                     <span>0</span>
//                     <span>0</span>
//                   </td>
//                   <td>view</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default VoucherReports




import React, { useEffect, useState, useCallback } from "react";
import "./VoucherReports.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { FileSpreadsheet, FileText } from "lucide-react";

const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100, "All"];
const API_URL = "https://payyug.in/api";

const getBase64ImageFromUrl = async (imageUrl) => {
  if (!imageUrl) return null;
  try {
    const response = await fetch(imageUrl, { mode: "cors" });
    if (!response.ok) return null;
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => reject(null);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Image loading failed:", error);
    return null;
  }
};

const VoucherReports = () => {

  const [vouchers, setVouchers] = useState([]);
  const [company, setCompany] = useState(null);


  // input filters
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // applied filters
  const [appliedFromDate, setAppliedFromDate] = useState("");
  const [appliedToDate, setAppliedToDate] = useState("");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

      const { profile } = useSelector((state) => state.userProfile);
    const dispatch = useDispatch();
  
    useEffect(() => {
      dispatch(fetchUserProfile());
    }, [dispatch]);

    // console.log("Arm",profile)


      /* ================= FETCH COMPANY DETAILS ================= */
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `${API_URL}/get-company?superAdminId=${profile?.superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (profile?.superAdminId) fetchCompany();
  }, [profile?.superAdminId]);

  /* ================= FETCH ================= */
  const fetchVouchers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("authToken");

      const res = await axios.get(
        `${API_URL}/ledger-entry/get-all-voucher`,
        {
          params: {
            superAdminId:profile?.superAdminId,
            branchId:profile?.branchId,
            page: currentPage,
            limit: rowsPerPage === "All" ? 100000 : rowsPerPage,
            fromDate: appliedFromDate || undefined,
            toDate: appliedToDate || undefined,
            // employeeId:localStorage.getItem("userId"),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setVouchers(res?.data?.data || []);

      const pagination = res?.data?.pagination || {};
      setTotalPages(pagination.totalPages || 1);
      setTotalRecords(pagination.totalRecords || 0);
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to fetch vouchers")
      setError(err?.response?.data?.message || "Failed to fetch vouchers");
    } finally {
      setLoading(false);
    }
  }, [currentPage, rowsPerPage, appliedFromDate, appliedToDate, profile]);

  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!fromDate || !toDate) {
      toast.warn("Please select From Date and To Date");
      return;
    }

    setAppliedFromDate(fromDate);
    setAppliedToDate(toDate);
    setCurrentPage(1);
    setHasSearched(true);
  };

  /* ================= FETCH AFTER SEARCH ================= */
  useEffect(() => {
    if (!hasSearched) return;
    fetchVouchers();
  }, [fetchVouchers, hasSearched]);

  /* ================= PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    setRowsPerPage(value === "All" ? "All" : Number(value));
    setCurrentPage(1);
  };

    // Helper for Row Index Computation
  const getRowIndex = (index) => {
    if (rowsPerPage === "All") return index + 1;
    return (currentPage - 1) * Number(rowsPerPage) + index + 1;
  };

  /* ================= EXPORT TO EXCEL ================= */
  const exportToExcel = () => {
    if (vouchers.length === 0) {
      toast.error("No data available to export");
      return;
    }

    const exportList = vouchers.map((item, index) => ({
      SN: getRowIndex(index),
      "Voucher No.": item.voucherNo || "N/A",
      "Voucher Type": item.voucherType || "N/A",
      Narration: item.narration || "-",
      Date: item.date ? new Date(item.date).toLocaleDateString() : "-",
      Status: item.status || "ACTIVE",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vouchers");
    XLSX.writeFile(workbook, `Voucher_Entries_Report.xlsx`);
  };

  /* ================= EXPORT TO PDF ================= */
  const exportToPDF = async () => {
    if (!vouchers || vouchers.length === 0) {
      toast.error("No data available to export");
      return;
    }

    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compress: true,
    });
    const pageWidth = doc.internal.pageSize.width;

    // Logo Section
    const logoX = 15;
    const logoY = 12;
    const logoSize = 22;

    if (company?.logoUrl) {
      const base64Logo = await getBase64ImageFromUrl(company.logoUrl);
      if (base64Logo) {
        try {
          const isJpeg =
            company.logoUrl.toLowerCase().includes(".jpg") ||
            company.logoUrl.toLowerCase().includes(".jpeg");
          const format = isJpeg ? "JPEG" : "PNG";

          doc.addImage(base64Logo, format, logoX, logoY, logoSize, logoSize);
        } catch (err) {
          console.warn("Logo draw error:", err);
        }
      }
    }

    // Company Details Header
    const nameX = logoX + logoSize + 8;
    const nameY = 16;
    const nameMaxWidth = pageWidth - nameX - 15;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(2, 44, 58);

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth
    );
    doc.text(companyNameText, nameX, nameY);

    let currentY = nameY + companyNameText.length * 5;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);

    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      nameMaxWidth
    );
    doc.text(addressText, nameX, currentY);
    currentY += addressText.length * 4;

    doc.text(`Email: ${company?.email || "-"}`, nameX, currentY);
    currentY += 4;

    doc.text(`Phone: ${company?.contact || "-"}`, nameX, currentY);
    currentY += 10;

    // Divider Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.3);
    doc.line(10, currentY, pageWidth - 10, currentY);

    // Title
    currentY += 8;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `Voucher Entries Report (${appliedFromDate || "Start"} to ${appliedToDate || "End"})`,
      pageWidth / 2,
      currentY,
      { align: "center" }
    );

    // Table Setup
    const tableColumn = [
      "SN",
      "Voucher No.",
      "Voucher Type",
      "Narration",
      "Date",
      "Status",
    ];

    const tableRows = vouchers.map((item, index) => [
      getRowIndex(index),
      item.voucherNo || "-",
      item.voucherType || "-",
      item.narration || "-",
      item.date ? new Date(item.date).toLocaleDateString() : "-",
      item.status || "ACTIVE",
    ]);

    autoTable(doc, {
      startY: currentY + 6,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 3,
        halign: "center",
        valign: "middle",
        textColor: [50, 50, 50],
      },
      headStyles: {
        fillColor: [2, 44, 58],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8.5,
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: [248, 250, 252],
      },
      margin: { left: 10, right: 10, top: 10, bottom: 15 },

      didDrawPage: function (data) {
        const pWidth = doc.internal.pageSize.width;
        const pHeight = doc.internal.pageSize.height;

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.2);
        doc.rect(8, 8, pWidth - 16, pHeight - 16);

        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        doc.text(
          `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
          pWidth / 2,
          pHeight - 11,
          { align: "center" }
        );
      },
    });

    doc.save("Voucher_Entries_Report.pdf");
  };
  return (
    <div className="voucher-container">
      <h1 className="voucher-heading">Voucher Reports</h1>

      {/* ================= TOP ================= */}
      <section className="voucher-top">
         {/* <div className="voucher-top-redirect">
          <h1>Quick Actions:</h1>
          <div className="voucher-redirect-btns">
            <button
              type="button"
              onClick={() => navigate("/Accountant/Voucher/Payment")}
            >
              <Plus size={15} /> Payment
            </button>
            <button
              type="button"
              onClick={() => navigate("/Accountant/Voucher/Receipt")}
            >
              <Plus size={15} /> Receipt
            </button>
            <button
              type="button"
              onClick={() => navigate("/Accountant/Voucher/Contra")}
            >
              <Plus size={15} /> Contra
            </button>
            <button
              type="button"
              onClick={() => navigate("/Accountant/Voucher/Journal")}
            >
              <Plus size={15} /> Journal
            </button>
          </div>
        </div> */}

        {/* ================= FILTER ================= */}
        <form className="voucher-form" onSubmit={handleSubmit}>
          <div className="voucher-form-section">
            <div className="voucher-form-input-fields">
              <label>From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="voucher-form-input-fields">
              <label>To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>

          <div className="voucher-form-submit-btn">
            <button type="submit">
              {loading ? "Loading..." : "Get Records"}
            </button>
          </div>
        </form>
      </section>

       {/* EXPORT ACTION BUTTONS */}
      <div className="voucher-pdf-download-btns">
        <button
          type="button"
          className="voucher-btn-excel"
          onClick={exportToExcel}
        >
          <FileSpreadsheet size={15} /> Download Excel
        </button>
        <button
          type="button"
          className="voucher-btn-pdf"
          onClick={exportToPDF}
        >
          <FileText size={15} /> Download PDF
        </button>
      </div>

      {/* ================= REPORT ================= */}
      <div className="voucher-report-container">
        {/* <h1>Voucher Reports</h1> */}

        <div className="voucher-report-filter-div">
          <div className="voucher-filter">
            <label>Show </label>
            <select value={rowsPerPage} onChange={handleItemsPerPageChange}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>

          {hasSearched && vouchers.length > 0 && (
            <div className="voucher-total-records">
              Total Records: {totalRecords}
            </div>
          )}
        </div>

        <div className="voucher-report-table-container">
          {error && <p className="error-text">{error}</p>}

          <table className="voucher-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Voucher No.</th>
                <th>Voucher Type</th>
                <th>Narration</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {!hasSearched ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                    Please select filters and click Get Records
                  </td>
                </tr>
              ) : loading ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                    Loading Vouchers...
                  </td>
                </tr>
              ) : vouchers.length > 0 ? (
                vouchers.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>{getRowIndex(index)}</td>
                    <td>{item.voucherNo || "-"}</td>
                    <td>{item.voucherType || "-"}</td>
                    <td>{item.narration || "-"}</td>
                    <td>
                      {item.date
                        ? new Date(item.date).toLocaleDateString()
                        : "-"}
                    </td>
                    <td>{item.status || "ACTIVE"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* PAGINATION BAR */}
      {hasSearched && rowsPerPage !== "All" && totalPages > 1 && (
        <div className="voucher-pagination-div">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default VoucherReports;

